import { render, staticRenderFns } from "./SignStatistics.vue?vue&type=template&id=36d168dc&scoped=true&"
import script from "./SignStatistics.vue?vue&type=script&lang=js&"
export * from "./SignStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SignStatistics.vue?vue&type=style&index=0&id=36d168dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d168dc",
  null
  
)

export default component.exports